import { Component, OnInit, Input, ViewChild, HostListener } from '@angular/core'
import { StoryblokService } from '../../services/storyblok.service'
import { NavService } from 'src/app/services/nav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.scss']
})

export class ProjectListComponent implements OnInit {
  public projectActive: boolean = false
  public projects
  public projectsLoaded: boolean = false

  public currentProject
  public currentIndex: number = null
  public currentSlides = []
  public activeDetails: number = null

  public sliderHeight: number

  @ViewChild('slider', {static: false}) slider: any;
  @Input() display_project_list: boolean
  @Input() _editable: any
  constructor(
    private router: Router,
    private storyBlokService: StoryblokService,
    private nav: NavService
  ) { }

  ngOnInit() {
    this.storyBlokService.getStories({'starts_with': 'projects'}).then(data => {
      this.projects = this.chunkProjects(data.stories, 1)
      this.projectsLoaded = true
    })
  }

  chunkProjects(projects, chunkSize) {
    let index = 0
    let arrayLength = projects.length
    let tempArray = []

    for(index = 0; index < arrayLength; index += chunkSize) {
      let thisChunk = projects.slice(index, index+chunkSize)

      tempArray.push(thisChunk)
    }

    return tempArray
  }

  clickToOpenProject(slug){
    this.router.navigate(['/project', slug]);
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
